import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from "styled-components";
import { getSuppliers } from '../../../../store/actions/dashboardAction';
import FilterListIcon from '@material-ui/icons/FilterList'
import {
	Table,
	Row,
	Col,
	ButtonGroup,
	Button,
	Modal,
	Form,
	Card,
	Collapse,
	ToggleButton,
	Toast,
} from "react-bootstrap";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SelectAndSearchComponent from "../../../../components/SelectAndSearchComponent/SelectAndSearchComponent";
import { fetchSupplierProducts, updateEnableDisableSupplierProduct } from '../services/supplierProductService';

const TableBodyWidth = styled.div`
  table tr th {
    white-space: nowrap;
    width: initial;
    scrollbar-width: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;

const SupplierProductList = (props) => {
	const [supplierProducts, setSupplierProducts] = useState([]);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const limit = 10;

	const [isLoading, setIsLoading] = useState(false);
	const [Error, setError] = useState(false);

	const [showFilter, setShowFilter] = useState(true);
	const [filters, setFilters] = useState({
		supplier: '',
		supplier_product_name: '',
		supplier_product_number: '',
		product_code: '',
		product_status: null,
	});
	const ProductStatusOptions = [
		{
			value: null,
			key: 'Select'
		},
		{
			value: true,
			key: 'Yes'
		},
		{
			value: false,
			key: 'No'
		}
	]
	const [filtersDirty, setFiltersDirty] = useState(false);
	// Handling filter changes
	const handleFilterChange = (field, value, autoApply = false) => {
		setFilters({
			...filters,
			[field]: value
		});
		// Auto-apply filters for select components
		if (autoApply) {
			setPage(1);
			setTimeout(() => {
				setFiltersDirty(prev => !prev);
			}, 0);
		}
	};
	// Apply filters
	const applyFilters = () => {
		setPage(1);
		setFiltersDirty(!filtersDirty);
	};

	// Handle keyboard events
	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			applyFilters();
		}
	};

	// Reset filters
	const resetFilters = () => {
		setPage(1);
		setFilters({
			supplier: null,
			supplier_product_name: '',
			supplier_product_number: '',
			product_status: null,
		});
		setFiltersDirty(!filtersDirty);
	};

	const [editId, setEditId] = useState(null);
	const [available,setAvailable] = useState(0);
	const [modalHead,setModalHead] = useState("");
	const [modalMessage,setModalMessage] = useState("");
	const [showDialog, setShowDialog] = useState(false);
	const [reloadFlag, setReloadFlag] = useState(false);

    const enableModal = (proId,proName) => {
        setEditId(proId);
        setAvailable(1);
        setModalHead("Enable");
        setModalMessage("Want to enable product - '"+proName+"'?");
        setShowDialog(true);
    };

    const disableModal = (proId,proName) => {
        setEditId(proId);
        setAvailable(0);
        setModalHead("Disable");
        setModalMessage("Want to disable product - '"+proName+"' ?");
        setShowDialog(true);
    };

	const enableProduct = () => {
		setModalHead("Updating");
		updateEnableDisableSupplierProduct(editId, available)
		.then(response => {
			setShowDialog(false);
			if(response.success) setReloadFlag(flag => !flag);;
		}).catch((error) => {
			setModalHead(error.response.data);
		});
	};

	useEffect(() => {
		const getSupplierProducts = async () => {
			if (isLoading) return;
			setIsLoading(true);
			setError(null);
			try {
				const activeFilters = {};
				Object.entries(filters).forEach(([key, value]) => {
					if (value !== '') {
						activeFilters[key] = value;
					}
				});
				const filtersToSend = Object.keys(activeFilters).length > 0 ? activeFilters : undefined;
				//   console.log("filtersToSend >>>>>>>>>>>>>>>>>> ", filtersToSend)
				const data = await fetchSupplierProducts(page, limit, filtersToSend);
				if (data && data.list) {
					setSupplierProducts(data.list);
					setTotalPages(data.total_pages);
				}
			} catch (err) {
				console.error('Error fetching SupplierProducts:', err);
				setError('Failed to fetch SupplierProducts. Please try again.');
			} finally {
				setIsLoading(false);
			}
		};
		getSupplierProducts();
	}, [page, filtersDirty, reloadFlag]);

	useEffect(() => {
		props.getSuppliers({});
	}, []);

	return (
		<>
			{/* Filter */}
			<Row className="mb-3">
				<Col>
					<Button
						variant="outline-primary"
						onClick={() => setShowFilter(!showFilter)}
						className="d-flex align-items-center"
					>
						<FilterListIcon className="mr-1" />
						{showFilter ? 'Hide Filters' : 'Show Filters'}
					</Button>
				</Col>
			</Row>

			<Collapse in={showFilter}>
				<Card className="mb-3">
					<Card.Body>
						<Row>
							<Col xs={12} sm={6} md={4} lg={2} className="mb-3">
								<Form.Group>
									<Form.Label>Product Code</Form.Label>
									<Form.Control
										type="text"
										value={filters.product_code}
										onChange={(e) => handleFilterChange('product_code', e.target.value)}
										onKeyPress={handleKeyPress}
										placeholder="Filter by product code"
									/>
								</Form.Group>
							</Col>
							<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
								<Form.Group>
									<Form.Label>Supplier Product Name</Form.Label>
									<Form.Control
										type="text"
										value={filters.supplier_product_name}
										onChange={(e) => handleFilterChange('supplier_product_name', e.target.value)}
										onKeyPress={handleKeyPress}
										placeholder="Filter by supplier product name"
									/>
								</Form.Group>
							</Col>
							<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
								<Form.Group>
									<Form.Label>Supplier Product Number</Form.Label>
									<Form.Control
										type="text"
										value={filters.supplier_product_number}
										onChange={(e) => handleFilterChange('supplier_product_number', e.target.value)}
										onKeyPress={handleKeyPress}
										placeholder="Filter by supplier product number"
									/>
								</Form.Group>
							</Col>
							<Col xs={12} sm={6} md={6} lg={2} className="mb-2">
								<Form.Group>
									<Form.Label>Supplier</Form.Label>
									<SelectAndSearchComponent
										options={props.suppliers}
										value={filters.supplier}
										onChange={(e) => handleFilterChange('supplier', e, true)}
										placeholder="Select Supplier"
										getOptionValue={(opt) => opt.store_users[0].first_name}
										getOptionLabel={(supplier) => (
											<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
												{supplier.store_users[0].first_name}
											</div>
										)}
									/>
								</Form.Group>
							</Col>
							<Col xs={12} sm={6} md={6} lg={2} className="mb-1">
								<Form.Group>
									<Form.Label>Product Status</Form.Label>
									<SelectAndSearchComponent
										options={ProductStatusOptions}
										value={filters.product_status}
										onChange={(e) => handleFilterChange('product_status', e, true)}
										placeholder="product status"
										getOptionValue={(opt) => opt.key}
										getOptionLabel={(opt) => (
											<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
												{opt.key}
											</div>
										)}
									/>
								</Form.Group>
							</Col>
						</Row>
						<Row className="mt-2">
							<Col className="d-flex justify-content-end">
								<Button
									variant="secondary"
									className="mr-2"
									onClick={resetFilters}
								>
									Reset
								</Button>
								<Button
									variant="primary"
									onClick={applyFilters}
								>
									Apply Filters
								</Button>
							</Col>
						</Row>
					</Card.Body>
				</Card>
			</Collapse>

			<Row>
				<Col lg={12}>
					<ButtonGroup toggle className="pull-right">
						<ToggleButton type="radio" variant="primary" name="radio" onClick={() => setPage(1)} disabled={page === 1}>
							First
						</ToggleButton>
						<ToggleButton type="radio" variant="primary" name="radio" onClick={() => {
							if (isLoading) return;
							setPage(prev => Math.max(prev - 1, 1));
						}} disabled={page === 1}>
							<ArrowBackIosIcon style={{ fontSize: "18px" }} />
						</ToggleButton>
						<ToggleButton type="radio" variant="outline-dark" disabled name="radio">
							Page {page} of {totalPages}
						</ToggleButton>
						<ToggleButton type="radio" variant="primary" name="radio" onClick={() => {
							if (isLoading) return;
							setPage(prev => Math.min(prev + 1, totalPages));
						}} disabled={page === totalPages}>
							<NavigateNextIcon style={{ fontSize: "25px" }} />
						</ToggleButton>
						<ToggleButton type="radio" variant="primary" name="radio" onClick={() => setPage(totalPages)} disabled={page === totalPages}>
							Last
						</ToggleButton>
					</ButtonGroup>
				</Col>
			</Row>
			<TableBodyWidth className="table-responsive" style={{ height: "calc(100vh - 280px)", marginTop: "5px" }}>
				<Table striped bordered hover>
					<thead>
						<tr>
							<th>ID</th>
							<th>Product name</th>
							<th>Product number</th>
							<th>Supplier</th>
							<th>Unit</th>
							<th>Retail Price</th>
							<th>Unit Cost</th>
							<th>Product Status</th>
						</tr>
					</thead>
					<tbody>
						{/* {console.log(supplierProducts)} */}
						{supplierProducts.map((supplierProduct, key) => (
							<tr key={key} id={`item-row-${supplierProduct.id}`}>
								<td>{supplierProduct.id}</td>
								<td>{supplierProduct.supplier_product_name}</td>
								<td>{supplierProduct.supplier_product_number}</td>
								<td>{supplierProduct.supplier && supplierProduct.supplier.first_name}</td>
								<td>{supplierProduct.unit}</td>
								<td>{supplierProduct.retail_price}</td>
								<td>{supplierProduct.unit_cost}</td>
								<td>{supplierProduct.product_status == 1 ? (
									<Button variant="success" onClick={() => disableModal(supplierProduct.id,supplierProduct.supplier_product_name)}>
										Enabled
									</Button>
								) : (
									<Button variant="danger" onClick={() => enableModal(supplierProduct.id,supplierProduct.supplier_product_name)}>
										Disabled
									</Button>
								)}</td>
							</tr>
						))}
					</tbody>
				</Table>
			</TableBodyWidth>

			<Modal show={showDialog} onHide={() => setShowDialog(false)}>
				<Modal.Header>
					<Modal.Title>{modalHead}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{modalMessage}</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShowDialog(false)}>
						Close
					</Button>
					<Button
						variant="success"
						autoFocus={true}
						onClick={enableProduct}
					>
						Enable
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

const mapStateToProps = (state) => ({
	suppliers: state.dashboardReducer.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
	getSuppliers: (data) => getSuppliers(data, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupplierProductList);